import React from 'react';

interface Props {
  size?: string
  value1: number
  value2: number
  min?: number
  max?: number
  results1?: string
  results2?: string
  className?: string
}


const TwoBars: React.FC<Props> = (props: Props) => {
  const min = props.min ? props.min : 0;
  const max = props.max ? props.max : 5;

  const percent1 = 100 * props.value1 / (max - min);
  const percent2 = 100 * props.value2 / (max - min);
  const barWidth1 = percent1 + "%";
  const barWidth2 = percent2 + "%";
  const hClass = props.size === "small" ? "h-4" : "h-8";
  let barClass = props.size === "small" ? "h-2" : "h-4";
  const extraClass = props.className ? " " + props.className : "";
  let resultsStyle = {};
  let containerStyle = {borderRadius: "16px"};
  let resultsClass = "text-xs text-indigo-900 mr-2";
  if (percent1 < 5) {
    const leftP = percent1 + 2 +  "%";
    resultsStyle = { left: leftP};
    resultsClass = "text-xs text-white absolute"
  }

  if (props.size === "small") {
    resultsClass += " text-xs";
    containerStyle = {borderRadius: "8px"};
  }
  let borderRadius1 = "16px 8px 8px 0";
  let borderRadius2 = "0 8px 8px 16px";

  if (props.value2 === 0) {
    barClass = props.size === "small" ? "h-4" : "h-8";
    borderRadius1 = "16px";
  }

  return (
    <div className={"bg-indigo-700 w-full " + hClass + extraClass} style={containerStyle}>
      <div className={"bg-peach-500 flex items-center justify-end " + barClass}
           style={{width: barWidth1, borderRadius: borderRadius1}}>
        {
          props.results1 &&
            <div className={resultsClass} style={resultsStyle}>
              {props.results1}
            </div>
        }
      </div>
      <div className={"bg-peach-300 flex items-center justify-end " + barClass}
           style={{width: barWidth2, borderRadius: borderRadius2}}>
        {
          props.results2 &&
            <div className={resultsClass} style={resultsStyle}>
              {props.results2}
            </div>
        }
      </div>
    </div>
  )
}

export default TwoBars;